import { createContext } from "react";

export const FeedPanelContext = createContext<{ closePanel?: () => void; openPanel?: () => void }>({});
